import styled from "styled-components";
import { FlexRow } from "styles/layout";
import { Theme } from "theme";

export const OptionContainer = styled(FlexRow)`
  padding: 8px ${Theme.bigPanelPaddingHorizontal};
`;

export const UpcomingOptionContainer = styled(OptionContainer)`
  color: dimgray;
`;

export const TournamentLogoContainer = styled.div<{ faded?: boolean }>`
  width: 20px;
  height: 20px;
  padding-right: 5px;
  ${({ faded }) => faded && `opacity: 0.65;`};
`;

export const PickemName = styled.div`
  flex-grow: 1;
`;

export const TimeLeft = styled.div``;
